import { render } from "./TypeSwitch.vue?vue&type=template&id=7a8467e8"
import script from "./TypeSwitch.vue?vue&type=script&lang=js"
export * from "./TypeSwitch.vue?vue&type=script&lang=js"

import "./TypeSwitch.vue?vue&type=style&index=0&id=7a8467e8&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__